import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingExclusion } from './types/Listing';

interface Query {
  rangeFrom?: string;
  rangeTo?: string;
}

export interface ListingExclusionsResponse {
  rangeFrom: string;
  rangeTo: string;
  dates: ListingExclusion[];
}

export default (makeCall: MakeCall) =>
  (listingId: number, { rangeFrom, rangeTo }: Query = {}) =>
    makeCall<ListingExclusionsResponse>(
      'GET',
      `/api/v2/listing/${listingId}/exclusions`,
      {
        query: { rangeFrom, rangeTo },
      },
    );
